import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Collapse, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { FiLock } from 'react-icons/fi';
import ButtonEdit from 'utils/buttons/ButtonEdit';
import { TablaPermisos } from 'sites/admin/inmobiliario/gestionarRoles/modals/components/TablaPermisos';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getRolByRealEstate } from 'redux/rolesSlice';
import ButtonAccept from 'utils/buttons/ButtonAccept';
import ButtonClose from 'utils/buttons/ButtonClose';
import { editCollabRole, getCollabById } from 'redux/colabsSlice';
// import ButtonDelete from 'utils/buttons/ButtonDelete';
import { checkPermission } from 'utils/checkPermission';
import { getRealEstateByUserId } from 'redux/realEstateSlice';
import AlternativeModalButtonsContainer from 'sites/common/AlternativeModalButtonsContainer';
import IconButton from 'components/common/IconButton';
import Select from 'react-select';

const Sucursal = ({
  branchOfficeToUser,
  isLast,
  isFirst,
  userLogged,
  setBranchOfficesUser,
  userId
}) => {
  const roles = useSelector(state => state.roles.data);
  const realEstate = useSelector(state => state.realEstate.realEstate);

  const [edit, setEdit] = useState(false);
  const [seePermisions, setSeePermisions] = useState(false);
  const [pickedRole, setPickedRole] = useState(branchOfficeToUser.roleId);

  const dispatch = useDispatch();

  useEffect(() => {
    userLogged?.id && dispatch(getRealEstateByUserId(userLogged.id));
  }, [userLogged]);

  useEffect(() => {
    realEstate?.id && dispatch(getRolByRealEstate(realEstate.id));
  }, [realEstate]);

  useEffect(() => {
    if (branchOfficeToUser.roleId) {
      setPickedRole(branchOfficeToUser.roleId);
    } else {
      setEdit(true);
    }
  }, [branchOfficeToUser, setPickedRole, setBranchOfficesUser]);

  const handleSave = async () => {
    if (pickedRole) {
      const response = await dispatch(
        editCollabRole(userId, {
          active: true,
          branchOfficeId: branchOfficeToUser.branchOfficeId,
          roleId: Number(pickedRole)
        })
      );

      if (response < 400) {
        await dispatch(getCollabById(userId));
        setEdit(false);
      }
    }
  };

  const handleDelete = async () => {
    const response = await dispatch(
      editCollabRole(userId, {
        active: false,
        branchOfficeId: branchOfficeToUser.branchOfficeId,
        roleId: 0
      })
    );

    if (response < 400) {
      await dispatch(getCollabById(userId));
      setEdit(false);
    }
  };

  const roleOptions = roles
    ? roles.map(role => ({
        value: role.id,
        label: role.name
      }))
    : [];

  return (
    <div>
      {isFirst && <div className="border-dashed-bottom mb-3" />}

      <div className="d-flex justify-content-between align-items-center">
        <div className="flex-1 position-relative">
          <h6 className="fs-0 mb-0">{branchOfficeToUser.branchOfficeName}</h6>
          <p className="mb-0">{branchOfficeToUser.branchOfficeAddress}</p>
          {edit && (
            <small className="text-muted">
              Rol actual:{' '}
              {!branchOfficeToUser.roleId ? ' -' : branchOfficeToUser.roleName}
            </small>
          )}
        </div>

        <Form.Group>
          {edit ? (
            <>
              <Form.Label>
                <FiLock /> Elegir Rol:
              </Form.Label>

              <Select
                classNamePrefix="react-select"
                className="mb-3"
                value={roleOptions.find(option => option.value === pickedRole)}
                onChange={selectedOption => setPickedRole(selectedOption.value)}
                options={roleOptions}
                placeholder="Elegir..."
                isSearchable={false}
              />
            </>
          ) : (
            <div className="d-flex gap-3 align-items-center">
              <Form.Label className="m-0">
                <FiLock /> Rol: {branchOfficeToUser.roleName}
              </Form.Label>

              {userLogged &&
                checkPermission('Edit users', userLogged) &&
                userId !== userLogged.id && (
                  <ButtonEdit funcion={() => setEdit(!edit)} />
                )}
            </div>
          )}
        </Form.Group>
      </div>

      {pickedRole && (
        <div className="form-control mt-3 p-0">
          <div
            className="d-flex justify-content-between align-items-center cursor-pointer px-3 p-2"
            onClick={() => setSeePermisions(prev => !prev)}
          >
            <div className="flex-1 position-relative">
              <h6 className="fs-0 mb-0">
                Permisos de{' '}
                {roles.find(rol => rol.id === Number(pickedRole))?.name}
              </h6>
            </div>

            <div className="d-flex gap-3 align-items-center">
              <FontAwesomeIcon
                icon={seePermisions ? 'chevron-up' : 'chevron-down'}
              />
            </div>
          </div>

          <Collapse in={seePermisions} timeout={0}>
            <div>
              <hr className="m-0" />
              <div className="p-3">
                <TablaPermisos
                  roleToPermission={
                    roles.find(rol => rol.id === Number(pickedRole))
                      ?.roleToPermission || []
                  }
                />
              </div>
            </div>
          </Collapse>
        </div>
      )}

      {edit && (
        <>
          {branchOfficeToUser.roleId && (
            <Col xs={12} sm={6} md={12} lg={3}>
              <div className="mb-4 d-block d-lg-flex" style={{ gap: 10 }}>
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Eliminar</Tooltip>}
                >
                  <div className="d-grid">
                    <IconButton
                      buttonSize="sm"
                      icon="trash-can"
                      onClick={handleDelete}
                      variant="danger"
                      className="px-2 mt-2"
                    />
                  </div>
                </OverlayTrigger>
              </div>
            </Col>
          )}

          <AlternativeModalButtonsContainer>
            <ButtonClose
              funcion={() => {
                setEdit(false);
                if (branchOfficeToUser.roleId) {
                  setPickedRole(branchOfficeToUser.roleId);
                } else {
                  setBranchOfficesUser(prev => {
                    const index = prev.findIndex(
                      branchOffice =>
                        branchOffice.branchOfficeId ===
                        branchOfficeToUser.branchOfficeId
                    );
                    const newBranchOfficesUser = [...prev];
                    newBranchOfficesUser.splice(index, 1);
                    return newBranchOfficesUser;
                  });
                }
              }}
              text="Cancelar"
              variant="secondary"
            />
            <ButtonAccept
              funcion={handleSave}
              text="Guardar"
              disabled={!pickedRole}
            />
          </AlternativeModalButtonsContainer>
        </>
      )}

      {!isLast && <div className="border-dashed-bottom my-3" />}
    </div>
  );
};

Sucursal.propTypes = {
  branchOfficeToUser: PropTypes.object.isRequired,
  isLast: PropTypes.bool.isRequired,
  isFirst: PropTypes.bool.isRequired,
  userLogged: PropTypes.object.isRequired,
  setBranchOfficesUser: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired
};

export default Sucursal;
